<script setup>
import { computed } from 'vue';

const props = defineProps({
  message: { type: Object, default: null },
});

const reactions = computed(() =>
  props.message?.content_attributes?.reactions || []
);
</script>

<template>
  <div v-if="reactions.length" class="flex gap-1 mt-0.5">
    <span
      v-for="(r, i) in reactions"
      :key="i"
      class="inline-flex items-center rounded-full bg-slate-100 dark:bg-slate-700 px-1.5 py-0.5 text-sm cursor-default"
      :title="r.sender"
    >{{ r.emoji }}</span>
  </div>
</template>
